/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserFlagUpdateCreateSchema
 */
export interface UserFlagUpdateCreateSchema {
    /**
     * 
     * @type {boolean}
     * @memberof UserFlagUpdateCreateSchema
     */
    completed: boolean;
}

/**
 * Check if a given object implements the UserFlagUpdateCreateSchema interface.
 */
export function instanceOfUserFlagUpdateCreateSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "completed" in value;

    return isInstance;
}

export function UserFlagUpdateCreateSchemaFromJSON(json: any): UserFlagUpdateCreateSchema {
    return UserFlagUpdateCreateSchemaFromJSONTyped(json, false);
}

export function UserFlagUpdateCreateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFlagUpdateCreateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'completed': json['completed'],
    };
}

export function UserFlagUpdateCreateSchemaToJSON(value?: UserFlagUpdateCreateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'completed': value.completed,
    };
}

